
const WeatherCard = ({ title, value, unit, digits=1, limits=null }) => {

  var alert_class = "bg-secondary";
  if (limits) {
    if (value >= limits.hard) {
      var alert_class = "bg-danger danger-glow";
    } else if (value >= limits.soft && value < limits.hard ) {
      var alert_class = "bg-warning text-dark";
     } else if (!value) {
      var alert_class = "bg-secondary";
    } else {
      var alert_class = "bg-success";
    }
  } 

  return (
    <div className={`card weather-card p-1 rounded-0 text-white ${alert_class} mb-1`} style={{ }}>
      <div className={`card-header p-1 ${alert_class} text-center fw-semibold fs-6 text-light text-opacity-50`}>{title}</div>
      <div className="card-body p-1 text-center align-middle" title={value ? title + " in " + unit : "Not available"}>
          <span className="card-value">{value ? value.toFixed(digits) : "N/A"}</span><span className="card-unit">{value ? unit : ""}</span>
      </div>
    </div> 
  );
};

export default WeatherCard;
 